import { render, staticRenderFns } from "./CrewProfile.vue?vue&type=template&id=1c65d2b8"
import script from "./CrewProfile.vue?vue&type=script&lang=js"
export * from "./CrewProfile.vue?vue&type=script&lang=js"
import style0 from "./CrewProfile.vue?vue&type=style&index=0&id=1c65d2b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports